import { useState } from "react";
import { genreList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function GenreGuide() {
  const [activeId, setActiveId] = useState(genreList[0].id);
  const active = genreList.find((g) => g.id === activeId) ?? genreList[0];

  return (
    <section id="genres" className="w-full bg-background-100 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="分类指南"
          title="韩漫、日漫、国漫：三条线索，三种阅读体验"
          desc="三者最大的差别在于画幅与上色习惯。先选定一条体系，题材和作品范围会立刻收窄，定位速度比漫无目的地翻榜单快很多。"
        />

        <div className="mt-10 flex w-full max-w-md mx-auto p-1 rounded-full bg-background-200/70 border border-background-300/60">
          {genreList.map((g) => (
            <button
              key={g.id}
              type="button"
              onClick={() => setActiveId(g.id)}
              aria-pressed={activeId === g.id}
              className={`flex-1 px-3 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                activeId === g.id
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {g.key}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-stretch">
          <div className="lg:col-span-5 relative rounded-lg overflow-hidden border border-background-200 bg-background-200 min-h-[280px] lg:min-h-full">
            <img
              src={active.image}
              alt={`${active.key}画风示意图`}
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black/70 to-transparent">
              <p className="font-heading text-lg font-bold text-background-50">{active.label}</p>
              <p className="mt-1 text-sm text-background-50/85">{active.tagline}</p>
            </div>
          </div>

          <div className="lg:col-span-7 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7 flex flex-col">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{active.desc}</p>

            <h3 className="mt-6 text-sm font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-list-check text-primary-600"></i>
              主要特征
            </h3>
            <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {active.traits.map((t) => (
                <li key={t} className="flex items-start gap-2 text-sm text-foreground-700 leading-relaxed">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>{t}</span>
                </li>
              ))}
            </ul>

            <div className="mt-auto pt-6">
              <div className="flex items-start gap-3 rounded-lg bg-accent-100/80 border border-accent-200 p-4">
                <i className="ri-user-heart-line text-xl text-accent-700"></i>
                <p className="text-sm text-accent-900 leading-relaxed">
                  <span className="font-bold">适合谁：</span>
                  {active.fit}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}